import axios from 'axios'
import {createSlice, createAsyncThunk, PayloadAction} from '@reduxjs/toolkit'
const api = '/api/'

export const organizationUnitList = createAsyncThunk(
  'school-organization-unit-list',
  async (params: any, thunkAPI) => {
    try {
      const {data} = await axios.get(`${api}school-organization-unit/list`, params)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors || 'Something went wrong')
    }
  }
)

export const organizationUnitStore = createAsyncThunk(
  'school-organization-unit-store',
  async (organizationData: any, thunkAPI) => {
    try {
      const {data} = await axios.post(`${api}school-organization-unit/store`, organizationData)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data || 'Something went wrong')
    }
  }
)

export const organizationUnitMove = createAsyncThunk(
  'school-organization-unit-move',
  async (organizationData: any, thunkAPI) => {
    try {
      const {data} = await axios.post(`${api}school-organization-unit/move`, organizationData)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data || 'Something went wrong')
    }
  }
)

export const organizationUnitDelete = createAsyncThunk(
  'school-organization-unit-delete',
  async (id: any, thunkAPI) => {
    try {
      const {data} = await axios.delete(`${api}school-organization-unit/delete/` + id)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data || 'Something went wrong')
    }
  }
)

export const getOrganizationUnits = createAsyncThunk(
  'school-organization-unit-organizations',
  async (params: any, thunkAPI) => {
    try {
      const {data} = await axios.get(`${api}school-organization-unit/organizations`, params)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors || 'Something went wrong')
    }
  }
)

export const getOrganizationChilds = createAsyncThunk(
  'school-organization-unit-childs',
  async (id: string, thunkAPI) => {
    try {
      const {data} = await axios.get(`${api}school-organization-unit/childs/${id}`)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors || 'Something went wrong')
    }
  }
)

export const getChildsByOraganizationId = createAsyncThunk(
  'school-organization-unit-childs',
  async (id: string, thunkAPI) => {
    try {
      const {data} = await axios.get(`${api}school-organization-unit/childs-by-organization/${id}`)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors || 'Something went wrong')
    }
  }
)

export const getOrganizationUnitLists = createAsyncThunk(
  'school-organization-unit-get',
  async (__, thunkAPI) => {
    try {
      const {data} = await axios.get(`${api}school-organization-unit/get`)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors || 'Something went wrong')
    }
  }
)

type OrganizationState = {
  errors: any
}

const initialState: OrganizationState = {
  errors: '',
}

export const organizationSlice = createSlice({
  name: 'school-organization',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(organizationUnitMove.rejected, (state, action: PayloadAction<any>) => {
      state.errors = action.payload
    })
  },
})

export const {reset} = organizationSlice.actions
export default organizationSlice.reducer
